/*
  NUDEBUM — product page
  Selección de variantes (color/talla), galería agrupada por color, barra fija mobile.
  Si el producto no tiene opción de color, el color navega entre productos hermanos (enlaces).
*/
(() => {
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  const money = (cents) => (window.nb && typeof window.nb.formatMoney === 'function' ? window.nb.formatMoney(cents) : `$${(cents / 100).toLocaleString('es-MX')}`);

  class NbProductPage extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('[data-section]');
      this.form = $('form[data-product-form]', this);
      this.data = JSON.parse($('[data-product-json]', this).textContent);
      this.colorPos = Number(this.dataset.colorPosition) || null;
      this.groupMedia = this.dataset.groupMedia === 'true';
      this.idInput = $('[data-variant-id]', this);
      this.addButton = $('[data-add-button]', this);
      this.addLabel = $('[data-add-label]', this);
      this.gallery = $('[data-gallery]', this);
      this.dots = $('[data-gallery-dots]', this);
      this.sizePicker = $('[data-size-picker]', this);
      this.sizeMessage = $('[data-size-message]', this);

      // Nunca hay talla preseleccionada: sin talla elegida no hay variante en el formulario.
      if (this.sizePicker) {
        $$('input', this.sizePicker).forEach((input) => (input.checked = false));
        this.idInput.value = '';
      }

      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-option]')) this.onOptionChange(e.target);
      });
      this.form.addEventListener('nb:missing-option', () => this.flagMissingSize());

      this.counter = $('[data-gallery-counter]', this);
      this.buildDots();
      let ticking = false;
      this.gallery.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => { this.syncDots(); ticking = false; });
      }, { passive: true });
      this.initZoom();
      this.initStickyBar();
      this.lowStock = $('[data-low-stock]', this);
    }

    selectedOptions() {
      const opts = [];
      $$('[data-option]:checked', this).forEach((input) => {
        opts[Number(input.dataset.option) - 1] = input.value;
      });
      return opts;
    }

    onOptionChange(input) {
      if (this.sizePicker && this.sizePicker.contains(input)) this.hideSizeMessage();
      const opts = this.selectedOptions();
      if (this.colorPos && Number(input.dataset.option) === this.colorPos) {
        const color = input.value;
        const label = $('[data-color-label]', this);
        if (label) label.textContent = color;
        this.updateSizeAvailability(color);
        if (this.groupMedia) this.filterGallery(color);
      }
      const variant = this.findVariant(opts);
      this.applyVariant(variant, opts);
    }

    findVariant(opts) {
      const needed = this.data.variants[0].options.length;
      if (opts.filter(Boolean).length < needed) return null;
      return this.data.variants.find((v) => v.options.every((o, i) => o === opts[i])) || null;
    }

    applyVariant(variant, opts) {
      const priceEl = $('[data-product-price] .nb-price__amount', this);
      const sizeChosen = !this.sizePicker || $('input:checked', this.sizePicker);
      if (variant) {
        this.idInput.value = variant.id;
        if (priceEl) priceEl.textContent = money(variant.price);
        this.setButton(variant.available ? 'add' : 'soldout');
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } else {
        this.idInput.value = '';
        this.setButton(sizeChosen ? 'unavailable' : this.colorHasStock(opts) ? 'add' : 'soldout');
      }
      const err = $('[data-form-error]', this);
      if (err) err.hidden = true;
      if (this.lowStock) this.lowStock.hidden = !(variant && variant.low);
      this.syncSet(variant);
      this.updateSticky();
    }

    /* La talla que la clienta eligió arriba se refleja en su fila de "Completa el set". */
    syncSet(variant) {
      const row = document.querySelector('[data-set-current]');
      if (!row || !variant) return;
      const input = row.querySelector(`input[value="${variant.id}"]`);
      if (input && !input.disabled) {
        input.checked = true;
        row.classList.remove('is-missing');
      }
    }

    colorHasStock(opts) {
      if (!this.colorPos) return this.data.variants.some((v) => v.available);
      const color = opts[this.colorPos - 1];
      return this.data.variants.some((v) => v.options[this.colorPos - 1] === color && v.available);
    }

    hideSizeMessage() {
      if (this.sizeMessage) this.sizeMessage.hidden = true;
      this.sizePicker && this.sizePicker.classList.remove('is-missing');
    }

    setButton(state) {
      const s = window.nb.strings;
      this.addButton.disabled = state !== 'add';
      this.addLabel.textContent = state === 'add' ? s.addToCart : state === 'soldout' ? s.soldOut : s.unavailable;
    }

    updateSizeAvailability(color) {
      if (!this.sizePicker) return;
      const sizePos = Number($('input', this.sizePicker).dataset.option);
      $$('input', this.sizePicker).forEach((input) => {
        const available = this.data.variants.some(
          (v) => v.options[this.colorPos - 1] === color && v.options[sizePos - 1] === input.value && v.available
        );
        input.disabled = !available;
        if (!available && input.checked) input.checked = false;
      });
    }

    filterGallery(color) {
      const slides = $$('.nb-product__slide', this.gallery);
      const hasColor = slides.some((s) => s.dataset.mediaColor === color);
      slides.forEach((s) => {
        s.hidden = hasColor && s.dataset.mediaColor !== '' && s.dataset.mediaColor !== color;
      });
      this.gallery.scrollTo({ left: 0 });
      this.buildDots();
    }

    visibleSlides() {
      return $$('.nb-product__slide:not([hidden])', this.gallery);
    }

    buildDots() {
      const visible = this.visibleSlides();
      if (this.dots) this.dots.innerHTML = visible.map((_, i) => `<span${i === 0 ? ' class="is-active"' : ''}></span>`).join('');
      this.updateCounter(0, visible.length);
    }

    currentIndex() {
      const visible = this.visibleSlides();
      const width = visible[0] ? visible[0].getBoundingClientRect().width : 1;
      return Math.max(0, Math.min(visible.length - 1, Math.round(this.gallery.scrollLeft / width)));
    }

    syncDots() {
      const index = this.currentIndex();
      if (this.dots) $$('span', this.dots).forEach((d, i) => d.classList.toggle('is-active', i === index));
      this.updateCounter(index, this.visibleSlides().length);
    }

    /* Contador "1 / 4": indica que hay más fotos (espalda, detalles) y en cuál vas. */
    updateCounter(index, total) {
      if (!this.counter) return;
      this.counter.textContent = total > 1 ? `${index + 1} / ${total}` : '';
    }

    /* Zoom: abre las fotos del color actual a pantalla completa, en la foto tocada. */
    initZoom() {
      this.zoom = document.getElementById('nb-zoom');
      if (!this.zoom) return;
      this.zoomTrack = $('[data-zoom-track]', this.zoom);
      this.zoomCount = $('[data-zoom-count]', this.zoom);
      this.gallery.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-zoom-open]');
        if (!trigger) return;
        const slides = this.visibleSlides();
        const index = slides.indexOf(trigger.closest('.nb-product__slide'));
        this.openZoom(slides, Math.max(index, 0), trigger);
      });
      this.zoomTrack.addEventListener('scroll', () => {
        const w = this.zoomTrack.clientWidth || 1;
        const i = Math.round(this.zoomTrack.scrollLeft / w);
        this.zoomCount.textContent = `${i + 1} / ${this.zoomTrack.children.length}`;
      }, { passive: true });
    }

    openZoom(slides, index, trigger) {
      this.zoomTrack.innerHTML = '';
      slides.forEach((slide) => {
        const img = $('img', slide);
        if (!img) return;
        const fig = document.createElement('figure');
        const big = document.createElement('img');
        big.src = img.currentSrc || img.src;
        if (img.srcset) big.srcset = img.srcset;
        big.sizes = '100vw';
        big.alt = img.alt;
        big.decoding = 'async';
        fig.appendChild(big);
        this.zoomTrack.appendChild(fig);
      });
      this.zoom.open(trigger);
      requestAnimationFrame(() => {
        this.zoomTrack.scrollLeft = index * this.zoomTrack.clientWidth;
        this.zoomCount.textContent = `${index + 1} / ${this.zoomTrack.children.length}`;
      });
    }

    flagMissingSize() {
      if (!this.sizePicker) return;
      if (this.sizeMessage) this.sizeMessage.hidden = false;
      this.sizePicker.classList.remove('is-missing');
      void this.sizePicker.offsetWidth;
      this.sizePicker.classList.add('is-missing');
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.sizePicker.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      const first = $('input:not([disabled])', this.sizePicker);
      setTimeout(() => first && first.focus({ preventScroll: true }), reduce ? 0 : 350);
    }

    initStickyBar() {
      this.stickyBar = this.section && $('[data-sticky-bar]', this.section);
      if (!this.stickyBar) return;
      const io = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.stickyBar.classList.toggle('is-visible', show);
        this.stickyBar.setAttribute('aria-hidden', String(!show));
        $('[data-sticky-add]', this.stickyBar).tabIndex = show ? 0 : -1;
      });
      io.observe(this.addButton);
      this.stickyButton = $('[data-sticky-add]', this.stickyBar);
      this.stickyButton.addEventListener('click', () => {
        if (this.addButton.disabled) return;
        // Sin talla: lleva a las tallas con el mensaje; nunca agrega una talla por defecto.
        if (!this.idInput.value) {
          this.flagMissingSize();
          return;
        }
        this.form.requestSubmit ? this.form.requestSubmit() : this.form.submit();
      });
      this.updateSticky();
    }

    /* La barra fija refleja exactamente la selección del formulario: color, talla y precio. */
    updateSticky() {
      if (!this.stickyBar) return;
      const s = window.nb.strings;
      const opts = this.selectedOptions();
      const color = this.colorPos ? opts[this.colorPos - 1] : ($('[data-color-label]', this) || {}).textContent;
      const sizeInput = this.sizePicker && $('input:checked', this.sizePicker);
      const sizeLabel = sizeInput ? sizeInput.nextElementSibling.textContent.trim() : null;
      const variant = this.idInput.value ? this.data.variants.find((v) => String(v.id) === this.idInput.value) : null;
      const price = variant ? variant.price : (this.data.variants.find((v) => !this.colorPos || v.options[this.colorPos - 1] === color) || this.data.variants[0]).price;
      const parts = [color && color.trim(), this.sizePicker ? (sizeLabel ? `${s.sizeLabel || 'Talla'} ${sizeLabel}` : s.sizePending) : null, money(price)].filter(Boolean);
      const meta = $('[data-sticky-meta]', this.stickyBar);
      if (meta) meta.textContent = parts.join(' · ');
      if (this.stickyButton) {
        this.stickyButton.textContent = this.addButton.disabled ? s.soldOut : this.idInput.value || !this.sizePicker ? s.addToCart : s.selectSize;
        this.stickyButton.disabled = this.addButton.disabled;
      }
    }
  }

  if (!customElements.get('nb-product-page')) customElements.define('nb-product-page', NbProductPage);
})();
